
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

enum DescriptionStatus {
  ERROR,
  NAME,
  DEFAULT,
}

@Component
export default class RegistroPontoHeader extends Vue {
  //#region [ PROPS ]
  @Prop({ default: null })
  readonly error: string;

  @Prop({ default: null })
  readonly name: string;

  @Prop({ default: '-' })
  readonly unidade: string;
  //#endregion



  //#region [ DATA ]
  currentTime: string = '';
  intervalId: number | null = null;
  animateDescription: boolean = false;
  shakeDescription: boolean = false;
  //#endregion



  //#region [ COMPUTED ]
  get descriptionText(): string {
    return this.error || this.name ||'Digite seu código';
  }

  get descriptionClasses() {
    return {
      'error-msg': this.descriptionStatus === DescriptionStatus.ERROR,
      'name-vinculo': this.descriptionStatus === DescriptionStatus.NAME,
      'move-left': this.animateDescription,
      'shake': this.shakeDescription,
    };
  }

  get descriptionStatus(): DescriptionStatus {
    if (this.error) {
      return DescriptionStatus.ERROR;
    }

    if (this.name) {
      return DescriptionStatus.NAME;
    }

    return DescriptionStatus.DEFAULT;
  }
  //#endregion



  //#region [ LIFECYCLE ]
  mounted() {
    this.updateTime();
    this.intervalId = window.setInterval(this.updateTime, 1000);
  }

  beforeDestroy() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  }
  //#endregion



  //#region [ WATCHERS ]
  @Watch('name')
  private nameOnChange(): void {
    this.animateDescription = false;

    if (this.name && this.descriptionStatus === DescriptionStatus.NAME) {
      this.animateDescription = true;
    }
  }

  @Watch('error')
  private errorOnChange(): void {
    this.shakeDescription = false;

    if (this.error && this.descriptionStatus === DescriptionStatus.ERROR) {
      this.shakeDescription = true;
    }
  }


  //#region [ METHODS ]
  updateTime() {
    const now = new Date();
    this.currentTime = now.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  }
  //#endregion
}
